import script from "./ArgonInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonInput.vue?vue&type=script&setup=true&lang=js"

import "./ArgonInput.vue?vue&type=style&index=0&id=cc15ab1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc15ab1c"]])

export default __exports__